<template>
  <div id="taisuidian">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>太歲殿</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">太歲殿</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/tai-sui-dian.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『太歲殿』</h5>

                <p class="project-description">
                  <span><b>一岁之尊神太岁星君 </b></span>
                </p>

                <p class="project-description">
                  <span
                    ><b
                      >太岁星君又称为太岁、岁君，民间视之为凶神，敬而远之
                      。据「荀子，儒效」记载：「武王之诛约也，行之日以兵忌东
                      南而迎太岁。」由此而知，中国早在殷末周初就有避「太岁
                      」的习俗
                    </b></span
                  >
                </p>

                <p class="project-description">
                  太岁星君又称为太岁、岁君，民
                  间视之为凶神，敬而远之。据「荀子，
                  儒效」记载：「武王之诛约也，行之
                  日以兵忌东南而迎太岁。」由此而知
                  ，中国早在殷末周初就有避「太岁」 的习俗。
                </p>

                <p class="project-description">
                  <span><b>岁星与太岁 </b></span>
                  太岁星君与金、木、水、火、土 五大行星之一的星有密切关係。木星
                  又称为岁星，据「汉书，律曆志」云：
                  「五星之合于五行，水合于辰星，火
                  合于突惑，金合于献白，木合于岁星 ，土合于镇星。」
                  古代天文学家将赤道从东向西等 分为十二个区域，称为「十二辰」，
                  又观测到木星每十二年运行一週天〔
                  根据现代天文学精密的观测，实际週
                  期十一，八六二年〕，即每年行经一
                  辰，所以木星又称为「岁星」，并且
                  以运行轨道作法为纪年的依据，称为 「岁星纪年法」。
                  但是由于木星是由西向东逆时针 方向运行的，与顺时针十二辰的方向
                  和顺序正好相反，此一岁星纪年法应
                  用起来很不方便，因此，古代天文学
                  家假想另外有颗星的运行方向正与岁
                  星相反，由东向西运行，此一颗假想
                  之星即称为「太岁」或「岁阴」，并
                  且依据所在位置的不同，而给予不同
                  的称谓，以方便纪年，据「尔雅，释
                  天」云：「太岁在寅日摄提格，在卯
                  曰单阏，在辰曰执一条，在巳曰大荒
                  落，在午曰敦胖，在未曰协力洽，在
                  申曰裙滩，在酉曰作噩，在戌阉茂，
                  在亥曰大渊献，在子曰困敦，在丑曰
                  亦奋若。」此法即称为「太岁纪念法」
                </p>

                <p class="project-description">
                  <span><b>太岁头上动土 </b></span>
                  据「土风录」云：「术家以太岁 为大将军，动土迁移者必避其方。」
                  由于「岁星为阳，右行于天；太岁为
                  阴，左行于地」，最迟从西汉开始，
                  中国人就普遍认为太岁所在的方位乃
                  为凶煞的方向。因此旧俗每有动土、
                  兴造、迁移、嫁娶之事，一定先要探
                  明太岁方位以避之。东汉王充「论衡
                  ，岁难篇」亦云：「移徙亦徙，抵太
                  岁凶（面对太岁〉，负太岁亦凶（背
                  对太岁〉。假令太岁在桉（桉：为正
                  北方〉，天下人人之皆不得南北徙〔
                  搬家〉，起宅、嫁娶亦皆避之。」 民间传说相信，若是在太岁头上
                  动土，便会挖到凶神的化身 团 肉球，招致灾祸。在唐代段成式「酉
                  阳杂俎」续集「支诺皋」中就记载了
                  「太岁头上动土」的故事：据说在莱
                  州墨（在今山东省〉住着王丰三兄弟
                  ，三人向来不信风水方位之说，一年
                  他们在献岁所在的方位挖坑，不料竟
                  然挖到一团蠕动的肉球。三人十分惊
                  骇，连忙用土掩埋，可是不但没有将
                  之埋没，反而一夜之间膨胀塞满庭院
                  ，不久王丰一家人几乎暴毙身亡。 在「广异记」，袁枚「子不语」
                  、元好问「绪夷坚志」中都有「太岁
                  头上动土」的记载，不过结局却不尽
                  相同，有人虽然同样在太岁方位挖到
                  了肉团，但是将之弃之江河，甚至鞭
                  打，却一点事都没有！酉元一九八六
                  年，在大陆甘肃省水登县连城村地工
                  二下挖出一团上白下黄，直径十四公
                  分、高十七公分、重二点六公斤的肉
                  球，经专家鑑定此为一菌种，名为「
                  太岁菌」，一般学者相信这就是中国
                  自古以来，风水方中所说的太岁之真 面目。
                </p>

                <p class="project-description">
                  <span><b>安太岁 </b></span>
                  太岁除了指是风水中方位之神煞 而言之外，「犯太岁」与人出生的年
                  份也有密切关係。若是一个人本命年
                  与值年太岁相同，民间称为「犯太岁
                  」，年支冲害刑者，则叫「冲太岁」。
                  所谓本命年，指的就是个人出生 年属六十甲子干支之年，其干支纪年
                  ，甲子年生，即甲子为本命，肖鼠；例如在壬午年，肖马，所以除了马年
                  出生者犯太岁之外。属鼠的子午相冲 ，也需拜太岁。
                  「太岁当头坐，无喜恐有高」， 民间相信若是一个人本命逢太岁，该
                  年必诸事不顺，必须奉太岁星君，俗
                  称「安太岁」。古谤：「避如趋吉，
                  择日不如选时，选时莫若积德。」 但太岁确是犯不得，因为，那是
                  地理磁场关係，以往不能用科学来解
                  释之时，就以煞气盖之，如今，学者
                  已证明瞭解风水、地理及宇宙奥秘等
                  等，煞气只不过是地理环境时间之改
                  变，引起了地灵的变化，地灵虽然不
                  能很清楚说明那是甚麽，但，中国的
                  科学家已经清楚知道磁场也是地灵的
                  一种，不过，地灵的涵盖面却还有许
                  多科学界还未能搞清楚物质变化。 以前曾有人发出疑问：中国人的
                  成语有道说：物以类聚。为甚麽太岁
                  却是对同个生肖的人不利呢？当人们
                  还不瞭解磁场的原理时，尽管心理面对岁非常顾忌，却不甘心，认为太岁
                  与自己是同属生肖，为甚麽却对同类 太胃。
                  过后，当人们瞭解了磁铁的原理 后，就感到那是必然的真理，因为，
                  磁铁的属性是同性相斥，异性相吸、
                  绝不妥协，不像人类，还可以来一个 同性恋的畸型发展。
                  太岁可以说是一个方向，一个地 灵，还有现代科学不知的奥秘，不过
                  ，有一点可以肯定的，环境改变，对
                  人类只有害处，没有好处，像现今的
                  科学是非常进步了，可是天灾病祸却
                  更多了，当然，那是地灵方向磁场等
                  有了变动，使到病毒、细菌也变种和
                  强大，不怕现有药物，像爱滋病是最
                  明确的例子，它原本只在猩猩的同类
                  中互相传染，而且，不易死亡，可是
                  ，它一变种，可以传给人类，而且是
                  无药可救，接着禽流感由鸡隻传给人
                  ，更奇怪的是，伊波拉病毒它来无踪
                  去无影，根本不知道为甚麽？就是科 学家也还不能对付的疾病。
                  安奉太岁就是要镇压，人类无法 预知的灾难、祸害、破财等等不幸的
                  事件。 &以，犯了太岁之人，要拜太岁
                  ，不过，只是安一个太岁在家是不足
                  够的，还要有一张由大师所施过法的
                  符，才可以从中中和磁场对有关生肖 者的影响。
                  一般的太岁符，如果没有得到有 道之士的加持，或施法唸过咒语，那
                  是绝对没有作用的，还要懂得读太岁
                  星君的咒，总之是件相当麻烦之事。 在这裡顺便要指出的是，苗大的
                  諸葛孔明有限公司所出品的神料，都
                  是依足古本做足诵经膜拜的工作，所
                  以灵力十足。但一些商人为了谋利，
                  根本不管别人用了有没有效果，只求
                  外形相似，可以卖出就好。所以苗大大师在这裡告诉大家，要用苗大的灵
                  力产品，必须认明諸葛孔明有限公司
                  的注册商标才购买。万一买错，得不
                  到灵力之助是小事，惹来孤魂野神才 是大事。
                  赢请认明諸葛孔明有限公司的注 册商标。
                </p>

                <p class="project-description">
                  <span><b>太岁方位与生育之奥秘 </b></span>
                  风水学有一派说法，认为房门或 睡床位于「太岁方」或「本命方」，
                  主不受孕，难有生儿育女之望。 所谓「太岁方」，是指当年的太
                  岁方位，例如「子」年以「子」为流
                  年太岁，所以「子」方在那一年便是
                  太岁方。又如「午」年以「午」为流
                  年太岁，所以「午」方在那一年即为 太岁方。
                  为了方便参考，现在把每年的太 岁方用图表别列出，一目了然：
                </p>

                <p class="project-description">
                  <span><b>【鼠】</b></span>
                  子年一一太岁方在子（正 北方）
                </p>

                <p class="project-description">
                  <span><b>【牛】</b></span>
                  丑年一一太岁方在丑（东 北偏北〉
                </p>

                <p class="project-description">
                  <span><b>【虎】</b></span>
                  寅年一一太岁方在寅（东 北偏北〉
                </p>

                <p class="project-description">
                  <span><b>【兔】</b></span>
                  卯年一一太岁方在卯（正 东方） 北偏北〉
                </p>

                <p class="project-description">
                  <span><b>【龙】</b></span>
                  辰年一一太岁方在辰（东 南偏东〉
                </p>

                <p class="project-description">
                  <span><b>【蛇】</b></span>
                  已年一一太岁方在已（东 南偏南〉 【
                </p>

                <p class="project-description">
                  <span><b>【马】</b></span>
                  午年一一太岁方在午（正〉
                </p>

                <p class="project-description">
                  <span><b>【羊】</b></span>
                  未年一一太岁方在未（西 南偏南〕
                </p>

                <p class="project-description">
                  <span><b>【猴】</b></span>
                  申年一一太岁方在申（西南偏西〕
                </p>

                <p class="project-description">
                  <span><b>【鸡】</b></span>
                  酉年一一太岁方在酉（正 西方）
                </p>

                <p class="project-description">
                  <span><b>【狗】</b></span>
                  戌年一太岁方在戌（西 北偏西〉
                </p>

                <p class="project-description">
                  <span><b>【猪】</b></span>
                  亥年一太岁方在亥（西 北偏北〉
                </p>

                <p class="project-description">
                  <span><b>十二生肖守护神 </b></span>
                  人的生长因素，并非先有内体即 可，必须有守护神、元神灵、指导灵
                  、辅助灵等诸灵助才有进展。人逢霉
                  运之时，就有破坏灵、恶魔灵、业力
                  灵、鬼灵、幽灵降临，其降临可能有
                  车祸意外、色灾、疾病、受难、死亡
                  、官司、刑罚、凶杀、争斗、破财、
                  事业逢逆、家人夫妻刑剋、子女无缘 分离、失怙恃、残破相等等。
                  守护神的功能，主旨在保护元神 灵、指导灵、辅助灵之吉灵不受甘扰
                  ，使其各尽其职，增加主人的善功，
                  消业障，增福泽。并可抗衡妥破坏灵
                  、恶魔灵、业力灵、鬼灵、幽灵的入
                  侵，保护其主人的吉祥平安，而不受 到伤害。
                  守护神功能有如此之伟大，故身 为肉体的主人，尽供奉之责，反，的
                  守护神无力感或受到伤害，连带的主
                  人将有受苦难之兆，致不分男女老幼
                  宗教信仰，均宜供奉自己之守护神，
                  供奉之法可即般若修德善堂八大守护
                  神殿供奉可保护本人吉样幸运纳福顺 刼。
                </p>

                <p class="project-description">
                  <span><b>流年犯太岁可以结婚办喜事吗？ </b></span>
                  对中国人而言，从传统封建社会 直到科技发达的今天，民间的忌讳在
                  衣食住行方面，仍然多到不得了，所
                  以有些时候，当我们想办某种较重大
                  的事件，总是因为父母长辈的意见，
                  或是受到边周朋友的影响，导致自己
                  举棋不定，不知要作何抉择才是正确
                  ，不听从吗？万一有甚麽差错便会受
                  到千夫所指，更不知要怨谁才是！ 而在我们週遭朋友之中，经常面
                  对被问这样的一个问題：流年犯太岁
                  ，还可以婚办喜事吗？其实在批判流
                  年运程的书籍裡，有这麽一句话：
                  <span><b>太岁当头座无喜必有祸 一喜挡三灾无喜祸事来 </b></span>
                  从中看到，就很明显的指出，流 年犯太岁虽是凶兆，但为了避开，可
                  以办喜事去化解。因此，如果流年犯
                  了动岁或冲太岁，最好有喜事来保全
                  年平安。当然，所谓竹喜事并不仅只
                  是婚而已，添丁生孩子也同样算是办
                  喜事。所以不论、添丁、嫁女儿、娶
                  媳，抱内外孙等都算是办喜事，同样
                  的可以避流年犯太种种的不如意，所
                  以说，流年犯太岁还是可以结婚的，
                  而脍是应该进行的。因此不必受道听
                  涂说的谣言所困扰，影响喜悦的心情
                  。应谁大胆并放心的进行。但紧记住
                  ，搬新家或过生日做大寿，只能说是 庆祝而不算是办喜事。
                  而有些人在流年犯太岁时，虽然 本身有办喜事，而却还是有些不如意
                  ，甚至更遭遇到其他的凶险，这又是 甚麽一回事呢？
                  其实，这得査一査个人的生辰八 字才能作定论，因为个人的运势，并
                  不是单从生肖过程就可作为标准的，
                  这关係到生辰八字，甚至住宅的风水
                  问题。就比如说，风痧丸可以止肚痛
                  ，但未必所有的肚痛病患吃了风痧丸
                  就会好的，因为他可以说是腹膜炎、
                  热气和和其他疾病，如果是如此的简 单，那麽又何必去看医生了？
                  在以往因为安奉太岁是个非常麻 烦的事，所以一般人都交由庙祝或算
                  命生先去处理，有关怎样处理，根本 不懂。
                  现在苗大大师有感于此，特地製 成了一套非常有效，和灵验十足的安
                  置太岁法，并可以安全破解太岁之煞
                  气转为吉祥之气，还能助长财气。 犯太岁的人只要购买一个苗大大
                  师所製成的太岁殿，将它当天膜拜焚
                  化即可将太岁的煞气转为助力，正所 谓的化千戈为玉帛。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="tai-sui-dian" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "TaiSuiDian",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/TaiSuiDian.vue